export default __webpack_public_path__ + "static/media/empty-file.03e8eb40.svg";